import axios from "axios";

const API_URL = process.env.REACT_APP_API_ENDPOINT
  ? process.env.REACT_APP_API_ENDPOINT.replace(/\/+$/, "") + "/"
  : "";

/**
 * Fetch the rich snapshot at a specific time.
 * Returns: { snapshot, exitRuleDataGrouped, exitClasses, summary }
 */
export const fetchEntrySnapshotAtTime = async ({ indexName, optionType, onlyDate, onlyTime, mode }) => {
  const params = { indexName, optionType, onlyDate, onlyTime, mode };
  const response = await axios.get(`${API_URL}api/entry-snapshot/at-time`, { params });
  return response.data;
};

/**
 * Fetch metadata (available dates and expiries).
 */
export const fetchEntrySnapshotMeta = async ({ indexName, optionType }) => {
  const params = { indexName };
  if (optionType) params.optionType = optionType;
  const response = await axios.get(`${API_URL}api/entry-snapshot/meta`, { params });
  return response.data;
};

/**
 * Fetch all available times for a given date/index/optionType/mode.
 */
export const fetchEntryAvailableTimes = async ({ indexName, optionType, onlyDate, mode }) => {
  const params = { indexName, optionType, onlyDate, mode };
  const response = await axios.get(`${API_URL}api/entry-snapshot/times`, { params });
  return response.data;
};

/**
 * Fetch entry class detail: all entry conditions evaluated against data.
 */
export const fetchEntryClassDetail = async ({ indexName, optionType, onlyDate, onlyTime, className, mode }) => {
  const params = { indexName, optionType, onlyDate, onlyTime, className, mode };
  const response = await axios.get(`${API_URL}api/entry-snapshot/entry-class-detail`, { params });
  return response.data;
};

/**
 * Fetch entry class trigger counts.
 */
export const fetchEntryTriggerCounts = async ({ indexName, optionType, className, mode }) => {
  const params = { indexName, optionType, className, mode };
  const response = await axios.get(`${API_URL}api/entry-snapshot/entry-class-trigger-counts`, { params });
  return response.data;
};

/**
 * Fetch date list from entry_data_point collection.
 */
export const fetchEntryDateList = async ({ indexName, mode, optionType }) => {
  const params = { indexName, mode };
  if (optionType) params.optionType = optionType;
  const response = await axios.get(`${API_URL}api/entry-snapshot/date-list`, { params });
  return response.data;
};
